/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { getDeducciones } from 'api/nominas/deducciones/deducciones';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

const NominasDeducciones = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [deducciones, setDeducciones] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _deducciones,
      ] = await Promise.all([
        getDeducciones(),
      ]);
      if (mounted) {
        setDeducciones(_deducciones);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const totalDeducciones = data.reduce((suma, actual) => suma + (actual?.importe || 0), 0);

  const columns = [
    {
      titleText: 'Deducciones',
      dataIndex: 'deduccion',
      key: 'deduccion',
      width: 250,
      render: (val) => {
        const _deduccion = deducciones.find((e) => e.id === val);
        return `${_deduccion?.clave} - ${_deduccion?.concepto}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  const summaryCells = [
    {
      label: 'Total',
      value: totalDeducciones,
      valueAlign: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          summaryCells={summaryCells}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default NominasDeducciones;
